/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignIntakeFormsDto } from '../models/AssignIntakeFormsDto';
import type { RequestCompletionApiResponse } from '../models/RequestCompletionApiResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExpertAppIntakeFormsService {
    /**
     * List intake form templates
     * Returns active intake form templates, optionally filtered by service type. Grouped by service type for navigation.
     * @param serviceTypeId Filter by service type ID
     * @returns any Intake form templates fetched successfully
     * @throws ApiError
     */
    public static intakeFormsControllerGetFormTemplatesV1(
        serviceTypeId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/intake-forms',
            query: {
                'service_type_id': serviceTypeId,
            },
        });
    }
    /**
     * Get client intake form responses
     * Returns a client's submitted intake form responses for this expert.
     * @param clientId Client ID (UUID)
     * @returns any Client intake form responses fetched successfully
     * @throws ApiError
     */
    public static intakeFormsControllerGetClientResponsesV1(
        clientId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/intake-forms/clients/{clientId}',
            path: {
                'clientId': clientId,
            },
            errors: {
                403: `Forbidden - No active booking with this client`,
            },
        });
    }
    /**
     * Get intake form response detail
     * Returns a specific intake form response with form schema and submitted answers.
     * @param responseId Intake form response ID (UUID)
     * @returns any Intake form response fetched successfully
     * @throws ApiError
     */
    public static intakeFormsControllerGetResponseDetailV1(
        responseId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/intake-forms/responses/{responseId}',
            path: {
                'responseId': responseId,
            },
            errors: {
                404: `Intake form response not found`,
            },
        });
    }
    /**
     * Assign intake forms to a client
     * Expert assigns one or more intake forms to a client. Skips forms already assigned.
     * @param requestBody
     * @returns any Forms assigned successfully
     * @throws ApiError
     */
    public static intakeFormsControllerAssignFormsToClientV1(
        requestBody: AssignIntakeFormsDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/intake-forms/assign',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid or inactive intake form IDs`,
                403: `Forbidden - No active booking with this client`,
            },
        });
    }
    /**
     * Get fresh download URL for client document
     * Returns a fresh signed download URL for a client-uploaded document (e.g. physiotherapist reports).
     * @param responseId Intake form response ID (UUID)
     * @param fileKey Storage file key for the uploaded document
     * @returns any Document download URL generated successfully
     * @throws ApiError
     */
    public static intakeFormsControllerGetDocumentDownloadUrlV1(
        responseId: string,
        fileKey: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/intake-forms/responses/{responseId}/documents/url',
            path: {
                'responseId': responseId,
            },
            query: {
                'fileKey': fileKey,
            },
            errors: {
                400: `Invalid file key for this intake form`,
                404: `Intake form response not found`,
            },
        });
    }
    /**
     * Request client to complete intake form
     * Expert sends an in-app reminder to the client for an incomplete intake form response.
     * @param responseId Intake form response ID (UUID)
     * @returns RequestCompletionApiResponse Completion request sent successfully
     * @throws ApiError
     */
    public static intakeFormsControllerRequestCompletionFromClientV1(
        responseId: string,
    ): CancelablePromise<RequestCompletionApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/intake-forms/responses/{responseId}/request-completion',
            path: {
                'responseId': responseId,
            },
            errors: {
                400: `This intake form is already completed by the client`,
                403: `Forbidden - No active booking with this client`,
                404: `Intake form response not found`,
                429: `Too many requests - max 3 reminders per hour for this intake response`,
            },
        });
    }
}
